<template>
  <el-dialog
          title="预览"
          width="600"
          :visible.sync="dialogVisible"
          @close="$emit('update:visible',false)"
          append-to-body>
        <div class="banner-list-img" style="min-height: 420px;max-height: 500px;overflow-y: auto;">
          <img :src="privaImgObj" alt="" style="width: 100%;">
        </div>
  </el-dialog>
</template>
<script>
  export default {
    name: "previewImgDialog",
    props: ["visible", "privaImgObj"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogVisible: this.visible
      };
    },
    created() {
    },
    methods: {}
  };
</script>

